//Import React Hooks
import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';


//selectors for redux :
import { useSelector, useDispatch } from "react-redux";

//created 
import VignettePhotoCarousel from '../vignettePhotoCarousel/VignettePhotoCarousel'

//MUI :
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import Alert from '@mui/material/Alert';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';

import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';


// API fetch
import axios from "axios";
import { baseURL } from '../../../config/api-config.js';


//Translate utils :
import { translator } from "../../../utils/translator.js"
import { poucesConvertor } from "../../../utils/poucesConvertor.js"

//import { useSelector, useDispatch } from "react-redux";
import { getLang, getLocation, getStepLocation, getPanier } from "../../../store/selectors.js"; //global state : shopping state
import { panierSlice } from '../../../store/panierSlice.js';
//const lang = useSelector(getLang) //global state : language
// translator(original, lang, ref)

export default function CardArticle({ article, dbTailles }) {

    const [articleSize, setArticleSize] = useState(article.taille_id[0]);
    const [currentQty, setCurrentQty] = useState(0);

    const panier = useSelector(getPanier)
    const location = useSelector(getLocation)
    const lang = useSelector(getLang) //global state : shopping step

    const dispatch = useDispatch();

    const [qteTailleArticle, setQteTailleArticle] = useState([]) //tableua des qte des taille (index = taille_id)

    useEffect(() => {
        console.log(panier)
        //on cherche dans le panier le nombre d'article avec la taille selectionnée
        let tri = panier.filter(art => art.article_id === article.id_article && art.taille_id === articleSize);
        //si non présent dans le panier : 0
        // sinon on récupere la qte de l'article du panier
        let qty = tri.length === 0 ? 0 : tri[0].qte;
        setCurrentQty(qty)


        if (panier) {

            let newList = []; //list des qty de chaque taille de l'article
            panier.filter(art => art.article_id === article.id_article).forEach((ligne) => {
                newList[ligne.taille_id] = ligne.qte
            })
            console.log(newList)
            setQteTailleArticle(newList)
        }

    }, [panier, articleSize])

    function getTailleInfo(taille) {
        let info = dbTailles.find(t => t.id_taille === taille).nom_taille;
        return poucesConvertor(info)
    }

    function getTailleFemme(article, taille) {

        if (taille < 2 || taille > 5) { //entre XS et L
            return ""
        }

        let correspondances = [
            {
                mixte: "XS",
                numerique: 34
            },
            {
                mixte: "S",
                numerique: 36
            },
            {
                mixte: "M",
                numerique: 38
            },
            {
                mixte: "L",
                numerique: 40
            },
        ]
        if (article.Categorie.id_categorie === 5 || article.Categorie.id_categorie === 7) {
            let equiv = correspondances.find(t => t.mixte === getTailleInfo(taille)).numerique

            console.log(getTailleInfo(taille))
            return "taille " + String(equiv);
        }
        else {
            return ""
        }

    }

    function triDeTaille(tailleIdList) {

        //taille Enfants d'abord
        let taillesEnfants = tailleIdList.filter(id => id > 8 && id < 15)

        //adultes tailles adultes
        let taillesAdultes = tailleIdList.filter(id => id < 8)

        //tailles Planches
        let taillesPlanches = triTaillesPlanches(tailleIdList.filter(id => id > 14))

        return taillesEnfants.concat(taillesAdultes).concat(taillesPlanches);


    }

    function triTaillesPlanches(list) {

        function getPiedsPouces(id) {
            let info = dbTailles.find(t => t.id_taille === id).nom_taille;
            let pieds = parseInt(info.split('p')[0]) //la taille en pied est indiquée avant le "p" dans le champ nom_taille
            let pouces = parseInt(info.split('p')[1].replace("pp", "")) || 0 //la taille en pied est indiquée avant le "p" dans le champ nom_taille
            return { pieds, pouces }
        }

        let tri = list.toSorted((id1, id2) => getPiedsPouces(id1).pieds < getPiedsPouces(id2).pieds ? -1 : getPiedsPouces(id1).pouces < getPiedsPouces(id2).pouces ? -1 : 1)

        return tri;
    }


    function changeQty(direction) {

        if (direction > 0) { //on ajoute
            if (currentQty <= 0) { //création
                dispatch(panierSlice.actions.insertArticle({
                    location_id: location.id_location,
                    article_id: article.id_article,
                    taille_id: articleSize,
                    qte: 1
                }));
            } else {//increment
                dispatch(panierSlice.actions.incrementArticleQty({
                    id: article.id_article,
                    taille: articleSize
                }));

            }

        } else { //on retire
            if (currentQty <= 1) { //suppression
                dispatch(panierSlice.actions.deleteArticle({
                    id: article.id_article,
                    taille: articleSize
                }));
            } else {//decrement
                dispatch(panierSlice.actions.decrementArticleQty({
                    id: article.id_article,
                    taille: articleSize
                }));

            }

        }

    }

    function isSelected(article, taille) {

        return getQtyTailleArticle(article, taille) > 0
    }

    function getQtyTailleArticle(article, taille) {

        return panier.filter(item => item.taille_id === taille && item.article_id === article.id_article).length

    }

    return (
        <div className="location-card-article">
            <div className="location-card-article-top">
                <VignettePhotoCarousel article={article} mode="gallery" />

            </div>
            <div className="location-card-article-middle">
                <h3>{article.Type.nom_type} {article.Categorie.nom_categorie}</h3>
                <p><strong>{article.description}</strong>  {article.infos}</p>

            </div>
            <div className="location-card-article-bottom">
                <div className="location-card-article-bottom-select-taille">
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">{translator("Choisissez votre taille", lang, "cardArticleTaille")}</InputLabel>
                        <Select
                            size="small"
                            className="location-card-article-size-item"
                            labelId="demo-simple-select-label"
                            label="Choisissez votre taille"
                            id="demo-simple-select"
                            value={articleSize}
                            onChange={e => setArticleSize(e.target.value)}
                        >{
                                triDeTaille(article.taille_id).map(taille => (
                                    <MenuItem key={taille} value={taille} className={isSelected(article, taille) === true ? "location-card-article-selected-item" : "location-card-article-size-item"}><article><p>{getTailleInfo(taille)} <span>{getTailleFemme(article, taille)}</span></p><p>{qteTailleArticle[taille] > 0 ? `x ${qteTailleArticle[taille]}` : ""}</p></article></MenuItem>

                                ))
                            }
)
                        </Select>
                    </FormControl>
                </div>
                <div className="location-card-article-bottom-intro-qte">
                    <p>{translator("Quantité d'articles", lang, "cardArticleQty")}</p>
                    <span></span>
                </div>
                <div className="location-card-article-bottom-select-qte">
                    <Button
                        variant="contained"
                        size="small"
                        disabled={currentQty <= 0}
                        onClick={_ => changeQty(-1)}><RemoveIcon /></Button>
                    <p>{currentQty}</p>
                    <Button
                        variant="contained"
                        size="small"
                        onClick={_ => changeQty(1)}><AddIcon /></Button>
                </div>

            </div>

        </div>
    )
}
